export default "__VITE_ASSET__6a0838df__"